import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ItemsFilterComponent } from './items-filter.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule, ReactiveFormsModule],
  declarations: [ItemsFilterComponent],
  exports: [ItemsFilterComponent],
})
export class ItemsFilterModule {}
